import React from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import {
  Grid,
  Alert,
  Switch,
  FormControlLabel,
} from "@mui/material";

/**
 * Tab „Externé objednávky" v Nastaveniach zákazníka (DSOK-442).
 *
 * Zapína príjem objednávok z externých systémov (audioEcho, WooCommerce) cez
 * POST /api/v1/orders/external. Autentifikácia je **Bearer JWT** (rovnako ako celé
 * verejné API /api/V1) — žiadne samostatné API kľúče.
 *
 * Uložené v dsokSettings.customer.externalOrders.enabled.
 */
const ExternalOrdersTab = ({ readOnly = false }) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext();

  const enabled = values?.customer?.externalOrders?.enabled === true;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Alert variant="outlined" severity="info">
          {t("pages.dsokDetails.externalOrders.info", {
            defaultValue:
              "Príjem objednávok z externých systémov (audioEcho, WooCommerce) cez POST /api/v1/orders/external. Autentifikácia je cez Bearer token (rovnako ako celé verejné API v1).",
          })}
        </Alert>
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Switch
              checked={enabled}
              disabled={readOnly}
              onChange={(e) =>
                setFieldValue(
                  "customer.externalOrders.enabled",
                  e.target.checked,
                )
              }
            />
          }
          label={t("pages.dsokDetails.externalOrders.enabled", {
            defaultValue: "Povoliť externé objednávky",
          })}
        />
      </Grid>
    </Grid>
  );
};

export default ExternalOrdersTab;
